module.exports = __webpack_public_path__ + "img/web1icon4.b3dee332.png";